import Axios from 'axios'
import { Message } from 'element-ui'
import store from '../store/index'
import { getItem } from '../utils/utils.js'

import utils from './utils.js'
const baseURL = utils.baseURL
export const request = (config1) => {
  const instance = Axios.create({
    baseURL,
    // timeout: 5000
  })
  // 请求拦截
  instance.interceptors.request.use(config => {
    console.log('token=' + getItem('webtoken'))
    if (getItem('webtoken')) {
      config.headers.authorization = getItem('webtoken')
    }
    console.log('roleId=' + getItem('roleId'))
    if (getItem('roleId')) {
      config.headers['Authorization-User-Role-Id'] = getItem('roleId')
    }
    return config
  }, error => Promise.reject(error))
  // 相应拦截
  instance.interceptors.response.use(res => {
    if (res.data.code == 'AUTHORIZE_HEADER_IS_NULL') {
      Message.error('登录失效， 重新登录')
      store.commit('setLoginTip',true)
      return
    }
    if (res.config.method === 'get') {
      if (res.status !== 200) return Message.error('请求失败')
      return res
    } else {
      return res.data
    }
  }, error => {
    // if (error.response?.status === 404) {
    //   Message.error(error.response.data.message)
    // }
    // if (error.response.status === 401) {
    //   Message.error('登录失效， 重新登录')
    //   store.commit('setLoginTip',true)
    // }
    // if (error.response.status === 500) {
    //   Message.error('服务器竟然开小差了')
    // }
    return error
  })
  return instance(config1)
}
